"use strict";

/* This mixin provides a simple setInterval method.
 *
 * Example:
 *
 *     var Component = React.createClass({
 *         ...
 *         componentDidMount: function() {
 *             this.setInterval(this.doSomething, 1000);
 *             this.setInterval(this.doSomethingElse, 5000);
 *         }
 *         ...
 *     });
 *
 * doSomething is called every second and doSomethingElse is called every five
 * seconds. Their intervals will be canceled automatically when the component
 * unmounts.
 */
var SetIntervalMixin = {
  componentWillMount: function() {
    this.intervals = [];
  },
  setInterval: function(fn, ms) {
    this.intervals.push(setInterval(fn, ms));
  },
  clearIntervals: function() {
    this.intervals.forEach(clearInterval);
    this.intervals = [];
  },
  componentWillUnmount: function() {
    this.clearIntervals();
  }
};

export default SetIntervalMixin;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/SetIntervalMixin.js
 **/